<router-outlet></router-outlet>
@if (isBrowser) {
  <tm-info-alert [cancelBtnLabel]="'modal.close' | translate" [title]="'modal.alertTitle' | translate"></tm-info-alert>
  <tm-info-confirm [okBtnLabel]="'modal.ok' | translate" [cancelBtnLabel]="'modal.close' | translate" [title]="'modal.corfirmTitle' | translate"></tm-info-confirm>
  <tm-error-alert [cancelBtnLabel]="'modal.close' | translate" [title]="'modal.errorTitle' | translate"></tm-error-alert>
  <tm-indeterminate-progress-bar></tm-indeterminate-progress-bar>
}

